import { createAction } from '@saucelabs/sl-util-redux';

import * as constants from './types';

export const handleSelectByVersion = createAction(constants.SELECT_BY_VERSION);
export const clearSelectByVersion = createAction(constants.CLEAR_SELECT_BY_VERSION);
